import { isStudentApp } from './../../../util/app-util';
import { useCallback } from 'react';
import { useMutation } from '@apollo/client';
import { SAVE_ATTEMPT_STUDENT, SAVE_ATTEMPT_EDUCATOR } from '../../queries/attempts/update-attempt';
import type { Attempt, AttemptStatus, FileUploadInput } from '../../schema-generated-types-student';

type AttemptData = {
  assignmentActivityId: number;
  status: AttemptStatus;
  dateStarted?: Date;
  dateCompleted?: Date;
  studentId?: number;
};

type AttemptStoreDispatch = {
  handleSaveAttempt: (data: AttemptData, fileUpload?: FileUploadInput) => Promise<Attempt>;
};

type AttemptStore = [null, AttemptStoreDispatch];

const useAttemptStore = (): AttemptStore => {
  const mutation = isStudentApp ? SAVE_ATTEMPT_STUDENT : SAVE_ATTEMPT_EDUCATOR;

  const [saveAttempt] = useMutation(mutation);

  const handleSaveAttempt = useCallback(async (data: AttemptData, fileUpload?: FileUploadInput) => {
    const result = await saveAttempt({
      variables: { data, ...(fileUpload && { fileUpload }) },
    });
    return result?.data?.saveAttempt;
  }, []);

  return [
    null,
    {
      handleSaveAttempt,
    },
  ];
};

export default useAttemptStore;
